export const isAdminLayout = () => Boolean(/admin/.test(window.location.href));
